<h2 class="sync-title">{{ 'permit.config.categories.sync_progress_title' | translate }}</h2>

<mat-progress-bar mode="determinate" [value]="data.progress$ | async"></mat-progress-bar>

<ul class="sync-steps">
    <li class="sync-step" *ngFor="let step of data.steps$ | async" [attr.data-state]="step.state">
        <mat-spinner *ngIf="step.state === 'active'; else stepIcon" diameter="16"></mat-spinner>
        <ng-template #stepIcon>
            <mat-icon class="step-icon" [class]="'state-' + step.state">{{ icon(step.state) }}</mat-icon>
        </ng-template>

        <span class="step-body">
            <span class="step-label">{{ labelKey(step) | translate }}</span>
            <span class="step-hint" *ngIf="hintKey(step) as hint">{{ hint | translate }}</span>
        </span>
    </li>
</ul>

<div class="sync-actions">
    <button mat-flat-button color="primary" [disabled]="!(data.done$ | async)" mat-dialog-close>
        {{ 'permit.config.common.close' | translate }}
    </button>
</div>
